import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import type { ILogAnalytics } from 'shared/middlewares/analytics/logger';
import type { SpEpic } from 'shared/middlewares/epic/epicMiddleware.factory';
import { matomoStarted } from 'state/userConsent/userConsent.actions';
export function startAnalyticsEpic(analytics: ILogAnalytics): SpEpic {
  return action$ =>
    action$.pipe(
      ofType('MATOMO_STARTING'),
      map(({ matomoBaseUrl, matomoSiteId, login, isUserInternal, companyName }) => {
        analytics.initialize({
          matomoBaseUrl,
          matomoSiteId,
          login,
          isUserInternal,
          companyName,
        });
        return matomoStarted();
      }),
    );
}
